webpackJsonp([225142215220636],{

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(9);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(47);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _bloomer = __webpack_require__(25);
	
	var _legalModule = __webpack_require__(572);
	
	var _legalModule2 = _interopRequireDefault(_legalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Legal = function Legal(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'libermatic. - ' + data.markdownRemark.frontmatter.title
	    }),
	    _react2.default.createElement(
	      _bloomer.Hero,
	      { isColor: 'primary' },
	      _react2.default.createElement(
	        _bloomer.HeroBody,
	        null,
	        _react2.default.createElement(
	          _bloomer.Container,
	          null,
	          _react2.default.createElement(
	            _bloomer.Title,
	            { isSize: 2 },
	            data.markdownRemark.frontmatter.title
	          ),
	          _react2.default.createElement(
	            _bloomer.Subtitle,
	            null,
	            data.markdownRemark.frontmatter.subtitle
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _bloomer.Container,
	      null,
	      _react2.default.createElement(_bloomer.Content, {
	        className: _legalModule2.default.section,
	        dangerouslySetInnerHTML: { __html: data.markdownRemark.html }
	      })
	    )
	  );
	};
	
	exports.default = Legal;
	
	Legal.propTypes = {
	  data: _propTypes2.default.shape({
	    html: _propTypes2.default.string
	  })
	};
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"section":"src-templates----legal-module---section---310Rd"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-legal-js-105d8dc2c1b86f1363ce.js